import React, { useEffect, useState } from "react";
import crmservices from '../../wsclient';
import ServiceVisitView from "./ServiceVisitView";
import { useTranslation } from "react-i18next";
import ServiceVisitDetailView from "./ServiceVisitDetailView";
import { createCustomFieldObj, getCustomFieldByKey } from "../../utils/util";
import ConfirmComponent from "../../components/Confirm";
import UploadFile from "../../components/UploadFile";

const MAXIUM_FILE = 3
export default function ServiceVisitController(props) {
    const typeId = props.activityTypes.serviceVisit;
    const { t } = useTranslation();
    const [listServiceVisit, setListServiceVisit] = useState([]); //list of activty remove
    const [showLoadingServiceVisit, setShowLoadingServiceVisit] = useState(true);
    const [showDetail, setShowDetail] = useState(false);
    // parse to modal detail
    const [activity, setActivity] = useState(null);
    const [showUploadFile, setShowUploadFile] = useState(false);
    const [filesUpload, setFilesUpload] = useState([]);
    const [files, setFiles] = useState([]);

    const [paging, setPaging] = useState({
        page: 1,
        size: 10,
        total: 0,
        has_more: false
    });

    const setShowProcessing = props.setShowProcessing;
    const showMessage = props.showMessage;

    useEffect(() => {
        if (typeId)
            onLoadListServiceVisit();
    }, [typeId]);

    // function to load list of activities remove device
    const onLoadListServiceVisit = async (page, size) => {
        setShowLoadingServiceVisit(true);
        let data = [];
        let _paging = {
            page: 1,
            size: 10,
            total: 0
        }
        try {
            const result = await crmservices.activities.getActivities({
                type_id: typeId,
                page: page ? page : paging.page,
                size: size ? size : paging.size,
                state: "PENDING",
                include_total: true
            });
            if (result.code === 'OK') {
                console.log("result:", result);
                data = result.data.content ? result.data.content : [];
                _paging = result.data.paging;
                if (_paging.size < paging.size) {
                    _paging.size = paging.size
                }
            }
            setListServiceVisit(data);
            setPaging(_paging)
        } catch (error) {
            console.log("load activity service visit error:", error);
        }
        setShowLoadingServiceVisit(false);
    }

    const handleChangePage = async (page) => {
        console.log("AAA page:", page);
        await onLoadListServiceVisit(page);
    }

    const handleChangeRowsPerPage = async (size) => {
        console.log("AAA size:", size);
        await onLoadListServiceVisit(1, size);
    }

    //function to handle show detail
    const onShowDetail = async (activity) => {
        setFiles([]);
        setShowProcessing(true);
        try {
            const result = await crmservices.activities.getActivity(activity.id);
            if (result.code == 'OK') {
                let activityData = result.data;
                // get contact detail
                if (activityData.contact) {
                    var result2 = await crmservices.contacts.getContact(activityData.contact.id);
                    if (result2.code == 'OK') {
                        activityData = { ...activityData, contact: { ...result2.data, id: activityData.contact.id } }
                    }
                }
                //
                setActivity(activityData)
                setShowDetail(true);
            } else {
                showMessage({
                    status: true,
                    message: t('NO_ACTIVITY_FOUND'), //TODO: correct message
                });
            }
        } catch (ex) {
            console.log("onShowDetail ex:", ex);
            showMessage({
                status: true,
                message: t('EXCEPTION_PROCESS'),
            });
        }
        setShowProcessing(false);
    }
    const onUploadFile = async () => {
        console.log("AAAA onUploadFile files: ", files)
        let _filesUploaded = [];
        try {
            console.log("files:", files)
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    console.log("files[i]:", files[i])
                    const result = await crmservices.attachments.uploadFiles({ file: files[i], disalbedContentType: true });
                    console.log("AAAA onUploadFile result: ", result)
                    if (result.code == 'OK' && result.data.id) {
                        const addContactResult = await onAddContactAttachment(result.data.id);
                        if (addContactResult) {
                            _filesUploaded.push(result.data.id)
                        }
                    }
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddContactAttachment = async (file_id) => {
        let successfull = false;
        try {
            const contactId = activity.contact.id;
            let result = await crmservices.attachments.addContactAttachment({
                file_id: file_id,
                contact_id: contactId
            });
            if (result.code == 'OK') {
                successfull = true;
            }
            console.log("AAAA onAddContactAttachment result: ", result)
        } catch (error) {
            console.log("onAddContactAttachment exception:", error);
        }
        return successfull;
    }

    const onUpdateActivity = async (note) => {
        setShowProcessing(true);
        let custom_fields = activity.custom_fields ? activity.custom_fields : [];
        console.log("custom_fields:", custom_fields);
        if (note)
            custom_fields = createCustomFieldObj(custom_fields, "notes", note);
        try {
            const fileUploaded = await onUploadFile();
            let strFileUploaded = fileUploaded && fileUploaded.length > 0 ? fileUploaded.join(",") : null;
            if (strFileUploaded) {
                let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
                if (fileCustomFields) {
                    fileCustomFields = fileCustomFields + "," + strFileUploaded
                } else {
                    fileCustomFields = strFileUploaded;
                }
                custom_fields.push({
                    key: 'attachments_file_id',
                    value: fileCustomFields
                })
            }
            const result = await crmservices.activities.updateActivity({ activity_id: activity.id, state: "COMPLETED", custom_fields: custom_fields });
            if (result.code == 'OK') {
                console.log(result.code)
                setShowDetail(false);
                props.onReloadServiceVisitList();
                onLoadListServiceVisit(paging.page, paging.size);
                showMessage({ status: true, message: t('UPDATE_ACTIVITY_SUCCESS') });
            }
            else showMessage({ status: true, message: t('UNKOWN_ERROR') })
        } catch (ex) {
            console.log("onUpdateActivity ex:", ex);
            showMessage({
                status: true,
                message: t('EXCEPTION_PROCESS'),
            });
        }
        setShowProcessing(false);
    }

    const onDeleteFile = (file) => {
        console.log("file==", file);
        const filesExist = files.filter(f => f.id !== file.id);
        setFiles(filesExist);
    }

    const uploadFiles = (files) => {
        if (files.length > MAXIUM_FILE) {
            showMessage({ status: true, message: t('error_max_files') })
            return false;
        }
        setFilesUpload(files);
    }

    const onSaveFilesState = () => {
        if (filesUpload && filesUpload.length > 0) setFiles(filesUpload);
        setShowUploadFile(false);
    }


    return (
        <>
            <ServiceVisitView
                listServiceVisit={listServiceVisit}
                paging={paging}
                showLoadingServiceVisit={showLoadingServiceVisit}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                onShowDetail={onShowDetail}
            />
            {showDetail && <ServiceVisitDetailView
                isOpen={showDetail}
                onClose={() => setShowDetail(false)}
                onSubmit={onUpdateActivity}
                activity={activity}
                files={files}
                setShowUploadFile={setShowUploadFile}
                onDeleteFile={onDeleteFile}
            />}

            {showUploadFile && <ConfirmComponent isOpen={showUploadFile} enableCloseButton={true}
                title={'Upload File'}
                otherMessage={<UploadFile onUploadFile={uploadFiles} isMultipleFile={true} />}
                onClose={() => setShowUploadFile(false)}
                onAction={() => onSaveFilesState()}
            />}
        </>
    )
}